import { render, staticRenderFns } from "./Dependent.vue?vue&type=template&id=885a3250&scoped=true&"
import script from "./Dependent.ts?vue&type=script&lang=ts&"
export * from "./Dependent.ts?vue&type=script&lang=ts&"
import style0 from "./Dependent.vue?vue&type=style&index=0&id=885a3250&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885a3250",
  null
  
)

export default component.exports